<template>
  <v-card
    width="100%"
  >
    <v-row
      justify="space-between"
      align="center"
      class="ma-0"
    >
      <v-card-title class="title">{{title}}</v-card-title>
      <transition name="error">
        <div class="error--text mr-4"
             v-if="error"
        >
          {{error}}
        </div>
      </transition>
    </v-row>
    <v-divider/>
    <v-card-text>
      <v-row
        justify="start"
        align="stretch"
        class="fill-height ma-0"
      >
        <v-col
          cols="4"
          class="inputs-col"
        >
          <fragment
            v-if="multiple"
          >
            <v-checkbox
              v-for="item in items"
              :id.prop="`processing-config-${item.id.toLowerCase()}`"
              :key="item.value"
              v-model="value"
              :label="item.name"
              :true-value="item.value"
              :disabled="disabled"
              @click.native="onChange"
              :false-value="false"
              class="my-8"
            >
              {{item.name}}
            </v-checkbox>
          </fragment>
          <fragment
            v-else
          >
            <v-radio-group
              v-model="value"
            >
              <v-radio
                v-for="item in items"
                :key="item.value"
                :label="item.name"
                :id.prop="`processing-config-${item.value.toLowerCase()}`"
                :value="item.value"
                @click.native="onChange"
                :disabled="disabled"
                class="my-8"
              >
              </v-radio>
            </v-radio-group>
          </fragment>
        </v-col>
        <v-col
          v-if="description"
          :id.prop='propId'
          cols="8"
        >
          <slot name="top"></slot>
          <v-card
            v-for="(desc, index) in description.texts"
            :key="desc"
            flat
          >
            <v-card-title class="subtitle-1 font-weight-bold">{{description.titles[index]}}:</v-card-title>
            <v-card-text>
              <transition name="text-fade" mode="out-in" appear>
                <div class="body-1" v-html="desc"></div>
              </transition>
            </v-card-text>
            <v-divider
              v-if="index < description.texts.length-1"
            >
            </v-divider>
          </v-card>
          <slot name="bottom"></slot>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import {find} from "lodash/collection"

  export default {
    name: "ProcessingConfig",
    model: {
      prop: "model",
      event: "change",
    },
    props: {
      multiple: {
        type: Boolean,
        default: false,
      },
      model: [String, Number, Boolean],
      title: {
        type: String,
        required: true,
      },
      error: [String],
      items: {
        type: [Object, Array],
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      value: null,
    }),
    methods: {
      onChange() {
        this.$emit("change", this.value)
      },
    },
    computed: {
      description() {
        if (!this.value)
          return null
        let value = find(this.items, ["value", this.value])
        if (value) return value.description
        return null
      },
      propId() {
        if (!this.value)
          return null
        let value = find(this.items, ["value", this.value])
        if (value) return `description-${((value.id) ? value.id.toLowerCase() : value.value.toLowerCase())}`
        return null
      }
    },
    created() {
      this.value = this.model
    },
    watch: {
      model(newModel) {
        this.value = newModel
      }
    }
  }
</script>

<style scoped lang="scss">

  .inputs-col {
    border-right: 1px solid rgba(0, 0, 0, 0.12);;
    overflow: hidden;

    input {
      white-space: normal;
      word-break: break-word;
    }
  }

  .text-fade-enter-active, .text-fade-leave-active {
    transition: opacity 800ms ease-in-out;
  }

  .text-fade-enter, .text-fade-leave-to {
    opacity: 0;
  }

  .error-enter-active, .error-leave-active {
    transition: all 150ms ease-in;
  }

  .error-enter, .error-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }
</style>

<style lang="scss">
  .gcp-imgs {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    img {
      width: 23%;
      height: auto;
    }
  }

  .coordinates-img {
    margin-top: 20px;
  }
</style>